module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "编辑分配权重",
      "width": "800",
      "mask-closable": false
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "modalForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formRule,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "选择课顾分组"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.onTeamTypeChange
    },
    model: {
      value: (_vm.formData.teamType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "teamType", $$v)
      },
      expression: "formData.teamType"
    }
  }, _vm._l((_vm.$constant.adviserGroup), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('ul', _vm._l((_vm.formData.adviserList), function(item) {
    return _c('li', [_c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": item.adviserName
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "权重"
      },
      on: {
        "on-change": _vm.onWeightChange
      },
      model: {
        value: (item.weight),
        callback: function($$v) {
          _vm.$set(item, "weight", $$v)
        },
        expression: "item.weight"
      }
    })], 1)], 1), _vm._v(" "), _c('Col', {
      attrs: {
        "span": 12
      }
    }, [_c('FormItem', {
      attrs: {
        "label": "渠道分类"
      }
    }, [_c('Select', {
      attrs: {
        "clearable": "",
        "multiple": "",
        "transfer": "",
        "placement": "top"
      },
      on: {
        "on-change": _vm.onTypeChange
      },
      model: {
        value: (item.channelTypes),
        callback: function($$v) {
          _vm.$set(item, "channelTypes", $$v)
        },
        expression: "item.channelTypes"
      }
    }, _vm._l((_vm.$constant.channelTypeEnum), function(item) {
      return _c('Option', {
        key: item.id,
        attrs: {
          "value": item.id
        }
      }, [_vm._v(_vm._s(item.text))])
    }), 1)], 1)], 1)], 1)
  }), 0)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.editModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.confirmAssign
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7675a358","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/crm/EditAssignWeightModal.vue
// module id = 1890
// module chunks = 8